import React, { useState, useCallback, memo } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import { useDispatch } from "react-redux"
import StickyHeadTable from "@/components/common/StickyHeadTable"
import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import { selectedParticipant } from "@/redux/actions/controlPanelSelectedParticipantAction"
import { controlPanelSidebarOpenComponent } from "@/redux/actions/controlPanelSidebarAction"
import useHandleModalShow from "@/hooks/useHandleModalShow"
import ModalDelete from "@/components/control-panel/control-panel-modal/ModalDelete"
import ModalReminderSetRole from "@/components/control-panel/control-panel-modal/ModalReminderSetRole"

const useStyles = makeStyles(() => ({
    participantNoRoleListTableWrapper: {
        color: "inherit",
        "& thead tr th": {
            fontWeight: "600",
        },
    },
    participantsWrapper:{
        maxHeight: "280px",
        overflow: "scroll",
        overflowX:"hidden"
    }
}))
const ParticipantNoRoleList = memo((props) => {
    const { participantNoRolesGroupedByRole } = props
    const classes = useStyles()
    const [columns] = useState(() => [
        { id: "firstName", label: "First name", minWidth: 130 },
        { id: "lastName", label: "Last name", minWidth: 130 },
        { id: "email", label: "Email", minWidth: 130 },
    ])
    const [targetParticipant, setTargetParticipant] = useState(null)
    const dispatch = useDispatch()

    const participantListEditItem = useCallback(
        (e) => {
            e.stopPropagation()
            const { rowIndex } = e.currentTarget.dataset
            const participantFound = participantNoRolesGroupedByRole.find((participant, index) => index === parseInt(rowIndex, 10))
            dispatch(selectedParticipant({ participant: participantFound }))
            const sidebarTag = process.env.SPARCA_CONTROL_PANEL_SIDEBAR_PARTICIPANT_SETTINGS
            dispatch(controlPanelSidebarOpenComponent(sidebarTag))
        },
        [participantNoRolesGroupedByRole]
    )

    const {
        modalItemShow: modalDeleteShow,
        handleClose: handleDeleteClose,
        handleModalItemShowChange: handleModalDeleteShowChange,
    } = useHandleModalShow()

    const {
        modalItemShow: modalRoleRemindShow,
        handleClose: handleRoleRemindClose,
        handleModalItemShowChange: handleModalRoleRemindShowChange,
    } = useHandleModalShow()

    const participantListReminderItem = useCallback(
        (e) => {
            e.stopPropagation()
            const { rowIndex } = e.currentTarget.dataset
            const participantFound = participantNoRolesGroupedByRole.find((participant, index) => index === parseInt(rowIndex, 10))
            setTargetParticipant(participantFound)
            handleModalRoleRemindShowChange(true)
        },
        [participantNoRolesGroupedByRole]
    )
    const participantListDeleteItem = useCallback(
        (e) => {
            e.stopPropagation()
            const { rowIndex } = e.currentTarget.dataset
            const participantFound = participantNoRolesGroupedByRole.find((participant, index) => index === parseInt(rowIndex, 10))
            setTargetParticipant(participantFound)
            handleModalDeleteShowChange(true)
        },
        [participantNoRolesGroupedByRole]
    )

    return (
        <>
            <Box m={3}>
                <Typography variant="h5" component="h2" style={{ color: "black" }}>
                    Participants without roles
                </Typography>
            </Box>
            <Box mt={1} className={`${classes.participantNoRoleListTableWrapper} ${classes.participantsWrapper}`}>
                {participantNoRolesGroupedByRole.length ? (
                    <StickyHeadTable
                        columns={columns}
                        rows={participantNoRolesGroupedByRole}
                        rowsPerPage={5}
                        extraColumns={[
                            {
                                column: { id: "Reminder", label: "Reminder", minWidth: 150, align: "center" },
                                action: (
                                    <Button onClick={participantListReminderItem} variant="contained" color="primary">
                                        Reminder
                                    </Button>
                                ),
                            },
                            {
                                column: { id: "Edit", label: "Edit", minWidth: 150, align: "center" },
                                action: (
                                    <Button onClick={participantListEditItem} variant="contained" color="primary">
                                        Edit
                                    </Button>
                                ),
                            },
                            {
                                column: { id: "remove", label: "Remove", minWidth: 150, align: "center" },
                                action: (
                                    <Button onClick={participantListDeleteItem} variant="contained" color="primary">
                                        Delete
                                    </Button>
                                ),
                            },
                        ]}
                    />
                ) : (
                    <Box m={3}>
                        <Typography>No Participants added yet</Typography>
                    </Box>
                )}
            </Box>
            <ModalDelete
                modalDeleteShow={modalDeleteShow}
                handleClose={handleDeleteClose}
                targetParticipantFromNoRoleTable={targetParticipant}
            />
            <ModalReminderSetRole
                modalRoleRemindShow={modalRoleRemindShow}
                handleClose={handleRoleRemindClose}
                targetParticipant={targetParticipant}
            />
        </>
    )
})

export default ParticipantNoRoleList
